import { ServiceCard } from '@/components/ui/ServiceCard';
import servicesData from '@/data/services.json';

export function ServicesSection() {
  return (
    <section className="bg-gray-800 py-16 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-medium text-white mb-6">
            {servicesData.title}
          </h2>
          <div className="max-w-4xl mx-auto text-white space-y-4">
            <p className="text-sm leading-relaxed">
              {servicesData.description}
            </p>
            <p className="text-sm leading-relaxed">
              {servicesData.additionalInfo}
            </p>
            <p className="text-sm leading-relaxed">
              {servicesData.callToAction}
            </p>
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {servicesData.services.map((service) => (
            <ServiceCard
              key={service.id}
              title={service.title}
              description={service.description}
              link={service.link}
              buttonText={service.buttonText}
              featured={service.featured}
              external={service.external}
            />
          ))}
        </div>
      </div>
    </section>
  );
}